// /src/components/Sidebar/HomeChatThread.jsx
import React from 'react';
import Home from '../Home'; // ✅ adjust if Home.jsx is in a different location

const HomeChatThread = ({ thread }) => {
  const { data = {}, name = '', id = '' } = thread;

  return (
    <Home
      existingChatHistory={data.chat || []}
      existingThreadName={name}
      existingThreadId={id}
    />
  );
};

export default HomeChatThread;

